// extracted by mini-css-extract-plugin
export default {"description":"Periodics_description__tZcuP","cardsGroup":"Periodics_cardsGroup__qvvzV","card":"Periodics_card__WQMgd","cardText":"Periodics_cardText__b2QLH"};